<template>
  <s-modal
    v-model="showModal"
    size="lg"
    :ok-title="$t('actions.continue')"
    @ok="editExternalLink"
    @cancel="closeModal"
    :ok-disabled="disableContinueButton"
  >
  <template #modal-header>
    <div
        class="session-modal__title"
        slot="modal-title"
      >
        {{ $t('module-information.edit-title') }}
      </div>
      <button
        class="close"
        type="button"
        aria-label="Close"
        @click="closeModal"
      >
        ×
      </button>
    </template>
    <b-container fluid>
      <b-row>
        <p>
          {{ $t('module-information.messages.MA004') }}
        </p>
        <p v-html="$t('module-information.messages.MA005')"></p>
        <p>
          {{ $t('module-information.messages.MA006') }}
        </p>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="12" class="px-0">
          <b-form-group
            :label="$t('module-information.display-name')"
            label-for="name"
          >
            <b-form-input
              v-model.trim="item.displayName"
              id="name"
              maxlength="250"
              autocomplete="off"
              :state="$bsStateValidator($v.item.displayName.$error)"
              @blur.native="$v.item.displayName.$touch()"
            ></b-form-input>
            <b-form-invalid-feedback
              :state="$bsStateValidator($v.item.displayName.$error)">
              {{ itemDisplayNameErrors }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="px-0">
          <b-form-group :label="$t('module-information.link')" label-for="link">
            <b-form-input
              v-model.trim="item.address"
              id="link"
              maxlength="1000"
              autocomplete="off"
              :state="$bsStateValidator($v.item.address.$error)"
              @blur.native="$v.item.address.$touch()"
            ></b-form-input>
            <b-form-invalid-feedback
              :state="$bsStateValidator($v.item.address.$error)">
              {{ itemAddressErrors }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>
  </s-modal>
</template>

<script>
import ModuleInformationService from '@/domain/services/installation/supervision/sensors/moduleInformation';
import { required, maxLength, minLength } from 'vuelidate/lib/validators';

export default {
  name: 'ModuleInformationEditModal',
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  validations() {
    return {
      item: {
        displayName: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(250),
        },
        address: {
          required,
          minLength: minLength(12),
          maxLength: maxLength(1000),
        },
      },
    };
  },
  data() {
    return {
      showItemDisplayNameErrors: false,
      showItemAddressErrors: false,
    };
  },
  computed: {
    disableContinueButton() {
      return this.$v.$invalid;
    },
    showModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    itemDisplayNameErrors() {
      if (!this.$v.item.displayName.minLength || !this.item.displayName) {
        return this.$t('messages.MG001.message', { 0: '2', 1: '250' });
      }
      if (!this.$v.item.displayName.maxLength) {
        return this.$t('messages.MA058.message', { NroCaracteres: '250' });
      }
      return null;
    },
    itemAddressErrors() {
      if (!this.$v.item.address.minLength || !this.item.address) {
        return this.$t('messages.MG001.message', { 0: '12', 1: '1000' });
      }
      if (!this.$v.item.address.maxLength) {
        return this.$t('messages.MA058.message', { NroCaracteres: '1000' });
      }
      return null;
    },
  },
  methods: {
    closeModal() {
      this.showModal = false;
      this.$emit('refresh');
    },
    onItemDisplayNameLostFocus() {
      this.showItemDisplayNameErrors = true;
    },
    onItemAddressLostFocus() {
      this.showItemAddressErrors = true;
    },
    async editExternalLink() {
      try {
        await ModuleInformationService.updateModuleInformation(this.item);
        this.$emit('refresh');
        this.showModal = false;
        this.$pushAlert({ code: 'MS006' });
      } catch (error) {
        this.$pushAlert({ code: 'ME010' });
      }
    },
  },
};
</script>

<style lang="sass" scoped>
::v-deep .modal-header
  display: block

@page
  margin: 0 auto

  @media print
    .modal-dialog,
    .modal-content
      max-width: 100vw
      width: 100vw
      height: 100vh
      margin: 0 auto

.modal-content
  position: absolute
  top: 0
  left: 0
  right: 0
  bottom: 0
.session-modal
  ::v-deep .modal-title
    width: 100%
  &__title
    font-size: 1.55rem
    text-transform: uppercase
    font-weight: bold
    word-wrap: break-word
    width: 100%
  &__hint
    color: var(--color-info)
</style>
